import React, { Component } from 'react';
import CartProduct from './CartProduct';

class CartMonth extends Component{
  constructor() {
    super();
    this.state = {
      subtotal: 0
    }
  }

  updateSubtotal(cart, month) {
    let new_subtotal = 0
    let filtered_cart = cart.filter(item => item.month === month)
    filtered_cart.map(item => {
        let item_total = item.product_price * item.quantity
        new_subtotal += item_total
        return new_subtotal
    })
    this.setState({subtotal: new_subtotal})
  }

  componentDidMount() {
    this.updateSubtotal(this.props.cart, this.props.id)
  }

  componentWillReceiveProps(nextProps) {
    this.updateSubtotal(nextProps.cart, nextProps.id)
  }

  render() {
    return(
      <div className="CartMonth">
        <p className="CartMonth-title">{this.props.title}</p>
        {
          this.props.cart.map((item, index) => {
            return (
               item.month === this.props.id
               ?
               <CartProduct key={index} addQuantity={this.props.addQuantity}
                 reduceQuantity={this.props.reduceQuantity} {...item} />
               :
               null
             )
          })
        }
        <p className="CartMonth-subtotal">{this.props.title} totalt: {this.state.subtotal}kr</p>
      </div>
    )
  }
}

export default CartMonth;



// WEBPACK FOOTER //
// ./src/components/CartMonth.jsx